var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeople({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 11.337C28.405 11.3212 28.2942 11.3212 28.1992 11.337C26.0142 11.2578 24.2725 9.46866 24.2725 7.252C24.2725 4.98783 26.0934 3.16699 28.3575 3.16699C30.6217 3.16699 32.4425 5.00366 32.4425 7.252C32.4267 9.46866 30.685 11.2578 28.5 11.337Z",
    stroke: "#1C3A77",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8692 22.8639C29.0383 23.2281 31.4292 22.8481 33.1075 21.7239C35.34 20.2356 35.34 17.7972 33.1075 16.3089C31.4133 15.1847 28.9908 14.8047 26.8217 15.1847",
    stroke: "#1C3A77",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.45251 11.337C9.54751 11.3212 9.65834 11.3212 9.75334 11.337C11.9383 11.2578 13.68 9.46866 13.68 7.252C13.68 4.98783 11.8592 3.16699 9.59501 3.16699C7.33085 3.16699 5.51001 5.00366 5.51001 7.252C5.52584 9.46866 7.26751 11.2578 9.45251 11.337Z",
    stroke: "#1C3A77",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0834 22.8639C8.91419 23.2281 6.52336 22.8481 4.84503 21.7239C2.61253 20.2356 2.61253 17.7972 4.84503 16.3089C6.5392 15.1847 8.96169 14.8047 11.1309 15.1847",
    stroke: "#1C3A77",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19 23.1641C18.905 23.1483 18.7942 23.1483 18.6992 23.1641C16.5142 23.085 14.7725 21.2958 14.7725 19.0791C14.7725 16.815 16.5934 14.9941 18.8575 14.9941C21.1217 14.9941 22.9425 16.8308 22.9425 19.0791C22.9267 21.2958 21.185 23.1008 19 23.1641Z",
    stroke: "#1C3A77",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3925 28.1513C12.16 29.6397 12.16 32.078 14.3925 33.5663C16.9258 35.2605 21.0742 35.2605 23.6075 33.5663C25.84 32.078 25.84 29.6397 23.6075 28.1513C21.09 26.473 16.9258 26.473 14.3925 28.1513Z",
    stroke: "#1C3A77",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.8a51416dd4da77c80650550f9e069af2.svg";
export { ForwardRef as ReactComponent };